import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function setMatchGoal(
  league_pk,
  round_pk,
  match_pk,
  by_team,
  playerIdGoal,
  playerIdAssist,
  goal_type
) {
  const token = Cookies.getToken();

  try {
    const res = await axios({
      method: 'POST',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/leagues/${league_pk}/rounds/${round_pk}/matches/${match_pk}/report_goal/`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        by_team: by_team,
        scorer: playerIdGoal,
        assist: playerIdAssist,
        goal_type: goal_type,
      },
    });
    return res;
  } catch (error) {
    return { error: error };
  }
}

